import React, { useEffect, useCallback } from 'react';
import './LearningReviewModal.css';

const LearningReviewModal = (props: any) => {
	
	const handleKey = useCallback((e: any) => {
		if (e.keyCode === 9) {//focus trap to prevent tabbing throught the element behind the popup
			let focusableParent = document.querySelector('.review-modal-background');
			if (!focusableParent) return;
			let focusable = focusableParent.querySelectorAll('.close-btn, .video-block, a, video');

			if (focusable.length) {
				let first = focusable[0] as HTMLElement;
				let last = focusable[focusable.length - 1] as HTMLElement;
				let shift = e.shiftKey;
				if (shift) {
					if (e.target === first) { // shift-tab pressed on first input in dialog
						last.focus();
						e.preventDefault();
					}
				} else {
					if (e.target === last) { // tab pressed on last input in dialog
						first.focus();
						e.preventDefault();
					}
				}
			}
		}
	}, [props.displayed]);

	const closeIntroductionPopup = (e: any) => {
		window.document.removeEventListener('keydown', handleKey);
		props.closeLearningReview();
	};

	useEffect(() => {
		window.document.addEventListener('keydown', handleKey);

		setTimeout(() => {
			let panel = document.getElementsByClassName('review-modal-block')[0] as HTMLElement;
			if (panel){
				console.log('learing review focused')
				panel.focus();
			}
			
		}, 100);

		
	}, [props.displayed]);


	return (
		props && props.displayed ?
			<div className="review-modal-background modal-disable-select">
				<div className="review-modal-container" style={{
					background: 'url(assets/startscreen/bg.png)',
					backgroundRepeat: 'no-repeat',
					backgroundSize: '100% 100%'
				}}>
					<div className="review-modal-block" tabIndex={0}>
						<img className="close-btn"
							src="./assets/startscreen/close.png"
							alt="close"
							role="button"
							tabIndex={0}
							onClick={closeIntroductionPopup}
							onKeyDown={(e: any) => {
								if (e.keyCode == 32 || e.keyCode == 13) { //32 - spacebar, 36 - enter
									closeIntroductionPopup(e);
								}
							}} />
						<h1>LEARNING REVIEW</h1>
						<h2>Welcome to the learning review screen.<br></br><br></br></h2>
						<div className="video-block" tabIndex={0}>
							<video id='learning-torn' tabIndex={0} controls width="100%" src="./assets/video/applying-a-tourniquet1.mp4">
								<track default
										kind="subtitles"
										srcLang="en"
										src="./assets/video/applying-a-tourniquet1.vtt" />
							</video>
							<div className="video-description">
								<h2>How to Apply A Tourniquet</h2>
								<p>Video example of the proper application when using a tourniquet. This example includes initial application, tightening, and securing the windless rod.</p>
							</div>
						</div>
						<div className="video-block" tabIndex={0}>
							<img src="./assets/img/pdfimg1.jpg" />
							<div className="video-description">
								<h2 role="paragraph">Overview of Bleeding Control Critical Actions</h2>
								<p>PDF overview for the critical actions that will occur during the playthrough of the bleeding control simulations. This document provides a summary of the critical learning step activities for each testing scenario. Please tap the link below to open it.</p>
								<p><a tabIndex={0} title="downloadable pdf" href="https://s3.amazonaws.com/cdn.creativevet.com/segs/deliverable/bleeding_control/pdfs/Learning+Review+-+Overview+of+Bleeding+Control+Critical+Actions.pdf" target='_blank'>Tap to open PDF here</a></p>
							</div>
						</div>
					</div>
				</div>
			</div>
			: <div></div>
	);
};

export default LearningReviewModal;
